import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './base-query';

const staffAPI = createApi({
    reducerPath: 'staffAPI',
    baseQuery,
    tagTypes: ['staff'],
    endpoints: (builder) => ({
        getAllStaff: builder.query({
            query: () => {
                return {
                    url: '/api/v1/staff',
                    method: 'GET'
                };
            },
            providesTags: ['staff'],
        }),

        getStaffById: builder.query({
            query: (staffId) => ({
                url: `/api/v1/staff/${staffId}`,
                method: 'GET',
            }),
            providesTags: (result, error, staffId) => [{ type: 'staff', id: staffId }],
        }),

        createStaff: builder.mutation({
            query: (payload) => ({
                url: '/api/v1/staff',
                method: 'POST',
                body: payload,
            }),
            invalidatesTags: ['staff'],
        }),

        updateStaff: builder.mutation({
            query: ({ staffId, payload }) => ({
                url: `/api/v1/staff/${staffId}`,
                method: 'PATCH',
                body: payload,
            }),
            invalidatesTags: (result, error, { staffId }) => ['staff', { type: 'staff', id: staffId }],
        }),

        deleteStaff: builder.mutation({
            query: ({ staffId }) => ({
                url: `/api/v1/staff/${staffId}`,
                method: 'DELETE'
            }),
            invalidatesTags: (result, error, { staffId }) => ['staff', { type: 'staff', id: staffId }],
        })
    })
});

export const {
    useGetAllStaffQuery,
    useGetStaffByIdQuery,
    useCreateStaffMutation,
    useUpdateStaffMutation,
    useDeleteStaffMutation
} = staffAPI;

export default staffAPI;